import AppLogResourcePagingResultModel from '../../generated/types/model/resource/AppLogResourcePagingResultModel';

export default class AppLogResourcePagingResultViewModel extends AppLogResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
